import { render, staticRenderFns } from "./payg-plan.vue?vue&type=template&id=b8622160&"
import script from "./payg-plan.vue?vue&type=script&lang=js&"
export * from "./payg-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports